module.exports = __webpack_public_path__ + "media/2-12.527ad716.wav";